import script from "./StatusKeyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusKeyButton.vue?vue&type=script&setup=true&lang=ts"

import "./StatusKeyButton.vue?vue&type=style&index=0&id=210dfe94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210dfe94"]])

export default __exports__